import filter from "lodash/fp/filter";
import flow from "lodash/fp/flow";
import map from "lodash/fp/map";

const getConstructionByType =
  (filteredType) =>
  ({ title, name, values }) => {
    if (name === "construction")
      return {
        title,
        name,
        values: values.filter(({ name }) => name === filteredType),
      };
    return { title, name, values };
  };

export const userChoiceValuesForPDF = ({
  userChoicesForUiV2,
  userChoiceValues,
}) => {
  const productSet = [
    "customise-pads",
    "customise-glove",
    "customise-blocker",
  ].filter((customise) => /true/.test(userChoiceValues[customise]));

  const productSetNames = {
    "customise-pads": {
      construction: "pad-construction",
      namesByType: [
        "graphic",
        "construction",
        "set-colors",
        "pads-specs",
        "personalization",
      ],
    },
    "customise-glove": {
      construction: "glove-construction",
      namesByType: [
        "graphic",
        "construction",
        "glove-color-colors",
        "glove-specs",
        "personalization",
      ],
    },
    "customise-blocker": {
      construction: "blocker-construction",
      namesByType: [
        "graphic",
        "construction",
        "blocker-color-colors",
        "blocker-specs",
        "personalization",
      ],
    },
  };

  return flow(
    map((set) => {
      return {
        productSet: set,
        productUserChoiceValues: flow(
          map(getConstructionByType(productSetNames[set].construction)),
          filter(({ name }) => productSetNames[set].namesByType.includes(name))
        )(userChoicesForUiV2),
      };
    })
  )(productSet);
};
